module.exports = __webpack_public_path__ + "img/0Q3B1666_L_Wood_MockedUp.5e3c2e45.jpg";